const info = {
  title: '让我遇见志同道合的你',
  subTitle: '金十招聘',
  input: '请输入职位进行搜索',
  desc: ['这里是一群正在探索财经世界的年轻人，朝气、冲劲、专业、极致是我们团队的标志。过去9年，我们在财经新闻资讯、视频节目、数据可视化、新媒体、交易课程等领域不断深耕，打造全面专业的金融资讯平台。接下来，我们还希望成为一个极具影响力的财经综合体。', '非常期待，你来和我们一起筑起这座梦想的高山。']
}

const welfareList = [
  {
    title: '薪资待遇',
    des: '行业优厚薪资，项目激励奖金',
    img: require('@/assets/index/welfare/薪资待遇@2x.png')
  },
  {
    title: '环境优雅',
    des: '滨江边办公大楼，环境舒适放松',
    img: require('@/assets/index/welfare/环境优雅@2x.png')
  },
  {
    title: '假期休息',
    des: '周末双休，国家法定节假日，带薪年假多多',
    img: require('@/assets/index/welfare/假期休息@2x.png')
  },
  {
    title: '餐饮补助',
    des: '每月午餐补贴，钱包Plus！',
    img: require('@/assets/index/welfare/餐饮补助@2x.png')
  },
  {
    title: '旅游活动',
    des: '团建聚餐，节日派对礼物',
    img: require('@/assets/index/welfare/旅游活动@2x.png')
  },
  {
    title: '社保福利',
    des: '试用期即有提供五险一金，每年体检',
    img: require('@/assets/index/welfare/社保福利@2x.png')
  }
]

export { info, welfareList }
